import { useMutation } from '@tanstack/react-query';
import { getAuthService } from '../services/auth.service';

/**
 * Custom hook to select an organization using AuthApi.
 *
 * @returns An object containing the mutation state and the `mutate` function to trigger the organization selection.
 */
export const useSelectOrganization = () => {
    return useMutation({
        mutationFn: async (organizationId: string) => {
            try {
                const response = await getAuthService().setCurrentOrganization(organizationId);
                return response;
            } catch (error) {
                console.error('Failed to select organization:', error);
                throw error;
            }
        },
    });
};
